import React from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import DSTooltip, { TooltipType } from '@elliemae/ds-basic/Tooltip';
import { PopperInteractions, PopperPositions } from '@elliemae/ds-basic/Popper';
import { DSIconSizes } from '@elliemae/ds-basic/Icon';
import DSButton from '@elliemae/ds-basic/Button';
import MoreOptionsVert from '@elliemae/ds-icons/MoreOptionsVert';
import QueryRemove from '@elliemae/ds-icons/QueryRemove';
import QueryAdd from '@elliemae/ds-icons/QueryAdd';
import ParenthesisAdd from '@elliemae/ds-icons/ParenthesisAdd';
import { ToolBarAnimation } from '../ToolBarAnimation/ToolBarAnimation.js';
import { TOOLBAR_ANIMATION_DURATION, DELAY_CLOSE, DELAY_OPEN } from '../helpers/constants.js';
import '@babel/runtime/helpers/esm/extends';
import '@elliemae/ds-shared/Animations/GrowRight';

/* eslint-disable react/prop-types */

var ConditionController = function ConditionController(_ref) {
  var _ref$onAddFilter = _ref.onAddFilter,
      onAddFilter = _ref$onAddFilter === void 0 ? function () {
    return null;
  } : _ref$onAddFilter,
      _ref$onAddRuleContain = _ref.onAddRuleContainer,
      onAddRuleContainer = _ref$onAddRuleContain === void 0 ? function () {
    return null;
  } : _ref$onAddRuleContain,
      _ref$onRemoveFilter = _ref.onRemoveFilter,
      onRemoveFilter = _ref$onRemoveFilter === void 0 ? function () {
    return null;
  } : _ref$onRemoveFilter,
      _ref$handleTooltipRow = _ref.handleTooltipRow,
      handleTooltipRow = _ref$handleTooltipRow === void 0 ? function () {
    return null;
  } : _ref$handleTooltipRow,
      _ref$buttonTriggerSiz = _ref.buttonTriggerSize,
      buttonTriggerSize = _ref$buttonTriggerSiz === void 0 ? DSIconSizes.M : _ref$buttonTriggerSiz,
      _ref$buttonTriggerTyp = _ref.buttonTriggerType,
      buttonTriggerType = _ref$buttonTriggerTyp === void 0 ? 'text' : _ref$buttonTriggerTyp,
      _ref$buttonActionSize = _ref.buttonActionSize,
      buttonActionSize = _ref$buttonActionSize === void 0 ? DSIconSizes.M : _ref$buttonActionSize,
      _ref$buttonActionType = _ref.buttonActionType,
      buttonActionType = _ref$buttonActionType === void 0 ? 'text' : _ref$buttonActionType,
      _ref$delayClose = _ref.delayClose,
      delayClose = _ref$delayClose === void 0 ? DELAY_CLOSE : _ref$delayClose,
      _ref$delayOpen = _ref.delayOpen,
      delayOpen = _ref$delayOpen === void 0 ? DELAY_OPEN : _ref$delayOpen,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      toolTipZIndex = _ref.toolTipZIndex;

  var _convertPropToCssClas = convertPropToCssClassName('query-builder-condition-controller'),
      cssClassName = _convertPropToCssClas.cssClassName,
      classNameBlock = _convertPropToCssClas.classNameBlock,
      classNameElement = _convertPropToCssClas.classNameElement;

  return /*#__PURE__*/React.createElement("div", {
    className: cssClassName
  }, /*#__PURE__*/React.createElement(DSTooltip, {
    delayClose: delayClose,
    delayOpen: delayOpen,
    interactionType: PopperInteractions.CLICK,
    isOpen: isOpen,
    onOpen: handleTooltipRow,
    placement: PopperPositions.LEFT,
    springAnimationComponent: /*#__PURE__*/React.createElement(ToolBarAnimation, {
      duration: TOOLBAR_ANIMATION_DURATION
    }),
    title: /*#__PURE__*/React.createElement("div", {
      className: classNameBlock('actions')
    }, /*#__PURE__*/React.createElement(DSButton, {
      buttonType: buttonActionType,
      className: classNameElement('remove-rule'),
      icon: /*#__PURE__*/React.createElement(QueryRemove, null),
      onClick: onRemoveFilter,
      size: buttonActionSize,
      containerProps: {
        'data-testid': 'query-remove-button'
      }
    }), /*#__PURE__*/React.createElement(DSButton, {
      buttonType: buttonActionType,
      className: classNameElement('add-rule'),
      icon: /*#__PURE__*/React.createElement(QueryAdd, null),
      onClick: onAddFilter,
      size: buttonActionSize,
      containerProps: {
        'data-testid': 'query-add-button'
      }
    }), /*#__PURE__*/React.createElement(DSButton, {
      buttonType: buttonActionType,
      className: "".concat(classNameElement('add-rule-container'), " no-border-right"),
      icon: /*#__PURE__*/React.createElement(ParenthesisAdd, null),
      onClick: onAddRuleContainer,
      size: buttonActionSize,
      containerProps: {
        'data-testid': 'parenthesis-add-button'
      }
    })),
    tooltipType: TooltipType.TOOLBAR,
    triggerComponent: /*#__PURE__*/React.createElement(DSButton, {
      buttonType: buttonTriggerType,
      icon: /*#__PURE__*/React.createElement(MoreOptionsVert, {
        color: ['neutral', '500']
      }),
      onClick: handleTooltipRow,
      size: buttonTriggerSize,
      containerProps: {
        'data-testid': 'condition-more-options-button'
      }
    }),
    zIndex: toolTipZIndex
  }));
};

export default ConditionController;
//# sourceMappingURL=ConditionController.js.map
